import { render, staticRenderFns } from "./NewPurchBread.vue?vue&type=template&id=c54d138e"
import script from "./NewPurchBread.vue?vue&type=script&lang=js"
export * from "./NewPurchBread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports